import { Counter } from "features/analytics/Components/Counter";
import Section from "features/analytics/Components/Section";
import { getEmotionData } from "features/analytics/analyticsHelper";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { EMPTY_GUID } from "utils/helpers";

function VOCAnalysisCounter() {
	const { t } = useTranslation();
    const { selectedFilterOptions, currentData } = useSelector((state) => state.analytics?.vocAnalysis);
    
	const getPersonaSentimentLevel = (interactions) => {
		if (!interactions || interactions?.length === 0) return 0;
		let total = 0;
		interactions?.forEach((interaction) => {
			total += interaction.sentimentLevel;
		});
		const res = (total / interactions?.length).toFixed(2);
		if (res === 0) return 0;
		return res;
	};

	const getContactSentimentLevel = (interactions) => {
		if (!interactions || interactions?.length === 0) return 0;

		let totalWeight = 0;
		let total = 0;

		interactions?.forEach((interaction) => {
			total += interaction.sentimentLevel * interaction?.numberOfInteractions;
			totalWeight += interaction?.numberOfInteractions;
		});

		const res = (total / totalWeight).toFixed(2);
		if (res === 0) return 0;
		return res;
	};

	const personasLevel = getPersonaSentimentLevel(currentData?.personaInteractions?.filter(int => int?.sentimentLevel) || []);
	const customerLevel = getContactSentimentLevel(currentData?.contactInteractions?.filter(int => int?.sentimentLevel) || []);

	const personaEmotionData = getEmotionData({ level: Math.round(personasLevel) });
	const customerEmotionData = getEmotionData({ level: Math.round(customerLevel) });

	return (
		<Section height="132">
			<Counter
				title={t("TOUCHPOINTS")}
				value={selectedFilterOptions?.touchpoints?.filter(opt => opt.id !== EMPTY_GUID)?.length}
				background="linear-gradient(178deg, #EFF6FF 1.53%, #FFF 104.23%)"
				border="#DBEAFE"
				icon="BULLSEYES-POINTER"
				iconColor="#3B82F6"
			/>
			<Counter
				title={t("JS_130")}
				value={selectedFilterOptions?.metrics?.filter(opt => opt.id !== EMPTY_GUID)?.length}
				background="linear-gradient(180deg, #FFF7ED 0%, #FFF 100%)"
				border="#FFEDD5"
				icon="CHART-LINE-UP-THIN"
				iconColor="#F97316"
			/>
			<Counter
				title={t("JS_148")}
				value={`${t(personaEmotionData?.description)} ${personasLevel}`}
				icon={personaEmotionData?.smiley}
				background={personaEmotionData.backgroundColor}
				border={personaEmotionData.borderColor}
				iconColor={personaEmotionData.textColor}
				textColor={personaEmotionData.textColor}
			/>
			<Counter
				title={t("CUSTOMER_SENTIMENT")}
				value={`${t(customerEmotionData?.description)} ${customerLevel}`}
				icon={customerEmotionData?.smiley}
				background={customerEmotionData.backgroundColor}
				border={customerEmotionData.borderColor}
				iconColor={customerEmotionData.textColor}
				textColor={customerEmotionData.textColor}
			/>
		</Section>
	);
}

VOCAnalysisCounter.displayName = "VOCAnalysisCounter";
export default VOCAnalysisCounter;
